import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useOnboardingContext } from '../../context/OnboardingContext/OnboardingContext';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import { ActionButton } from '../Button/Button';
import { Decoration } from './Decoration';
import styles from './styles';
export const OnboardingDecoration = ({ asStandAlonePage }) => {
    const { t: text } = useTranslation();
    const navigate = useNavigate();
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    const { updateStep, onboardingContextState: { step }, } = useOnboardingContext();
    const ctaButtons = asStandAlonePage ? (_jsxs(Box, { sx: styles.ctaWrapper(isDesktop, isTablet), mb: 4, children: [_jsx(ActionButton, { type: 'secondary', text: text('SET_UP_SMS_GO_BACK'), onClick: () => navigate(-1) }), _jsx(ActionButton, { type: 'primary', text: text(step === 0 ? 'ONBOARDING_COMPLETE_BUTTON' : 'CONTINUE'), onClick: () => updateStep(step + 1) })] })) : (_jsx(_Fragment, {}));
    const imagePath = step === 0 ? '/assets/images/onboarding-deco-step0.svg' : '/assets/images/onboarding-deco.svg';
    const title = text('ONBOARDING_DECO_TITLE');
    const titleBold = text('ONBOARDING_DECO_TITLE_BOLD');
    const decoText = text('ONBOARDING_DECO_TEXT');
    return (_jsx(Decoration, { asStandAlonePage, imagePath, title, titleBold, decoText, ctaButtons }));
};
